<div class="py-4" *ngIf="departments.length > 0">
  <div class="container-fluid">
    <ngx-slick-carousel class="carousel inner-carousel" #slickModal="slick-carousel" [config]="sliderConfig"
      (init)="changeEvent($event)" (afterChange)="changeEvent($event)">
      <div ngxSlickItem class="carousel-card mx-2" *ngFor="let depart of departments"
        [style.background-image]="'url(' + depart.image + ')'">
        <div class="overlay">
          <div class=" m-auto">
            <h5 class="titleDepartment ">{{ depart.title }}</h5>
            <div class="borderDiv"></div>
            <p class="departmentDes ">{{ depart.description }}</p>
            <button class="btnGreen">اقرأ المزيد</button>
          </div>

        </div>
      </div>
    </ngx-slick-carousel>

    <!-- Custom arrows -->
    <div class="pt-4 arrows-container">
      <button class="btn btnStyle" (click)="moveSlider(false)">
        <img src="../../../assets/IconARROW.png" />

      </button>
      <button class="btn btnStyle" (click)="moveSlider(true)">
        <img src="../../../assets/Iconarrowl.png" />
      </button>
    </div>
  </div>
</div>